// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/weight.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'weight',
	post: false,
	require: function(config, filter) { return sorted('weight', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('g.game_weight_avg', sortReverse('weight', filter), sortPriority('weight', filter))
	}
}
